// extracted by mini-css-extract-plugin
module.exports = {"noScrolling":"layout_noScrolling__f27Q7","body":"layout_body__oiEIT","container":"layout_container__116GV"};